
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"17","viewBox":"0 0 21 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.49 6.19L19.49 5.64L10.49 0.640002H10.38C10.3187 0.614081 10.2551 0.593992 10.19 0.580002H10H9.82C9.75168 0.594001 9.68474 0.614081 9.62 0.640002H9.51L0.51 5.64C0.356102 5.72722 0.228094 5.8537 0.139034 6.00654C0.0499749 6.15938 0.00305176 6.33311 0.00305176 6.51C0.00305176 6.6869 0.0499749 6.86062 0.139034 7.01346C0.228094 7.1663 0.356102 7.29278 0.51 7.38L3 8.76V13.5C3 14.2957 3.31607 15.0587 3.87868 15.6213C4.44129 16.1839 5.20435 16.5 6 16.5H14C14.7956 16.5 15.5587 16.1839 16.1213 15.6213C16.6839 15.0587 17 14.2957 17 13.5V8.76L19 7.64V10.5C19 10.7652 19.1054 11.0196 19.2929 11.2071C19.4804 11.3946 19.7348 11.5 20 11.5C20.2652 11.5 20.5196 11.3946 20.7071 11.2071C20.8946 11.0196 21 10.7652 21 10.5V7.06C20.9997 6.88281 20.9523 6.70887 20.8627 6.55601C20.7731 6.40314 20.6445 6.27683 20.49 6.19ZM15 13.5C15 13.7652 14.8946 14.0196 14.7071 14.2071C14.5196 14.3946 14.2652 14.5 14 14.5H6C5.73478 14.5 5.48043 14.3946 5.29289 14.2071C5.10536 14.0196 5 13.7652 5 13.5V9.87L9.51 12.37L9.66 12.43H9.75C9.833 12.4405 9.917 12.4405 10 12.43C10.083 12.4405 10.167 12.4405 10.25 12.43H10.34C10.3931 12.4188 10.4438 12.3985 10.49 12.37L15 9.87V13.5ZM10 10.36L3.06 6.5L10 2.64L16.94 6.5L10 10.36Z","fill":"currentColor"}})])
          )
        }
      }
    